
import React from "react";
import {
  Sheet,
  SheetContent,
} from "@/components/ui/sheet";
import PaymentDialogHeader from "./PaymentDialogHeader";
import PaymentDialogContent from "./PaymentDialogContent";
import { ClientSubscription } from "@/models/Client";

interface PaymentDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  clientId: string;
  clientName: string;
  client: any;
  subscription?: ClientSubscription;
}

const PaymentDialog: React.FC<PaymentDialogProps> = ({
  open,
  onOpenChange,
  clientId,
  clientName,
  client,
  subscription,
}) => {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent 
        side="bottom" 
        className="h-screen w-full rounded-none border-0 p-0 flex flex-col safe-area-aware ios-modal-safe pwa-modal-header-fix pt-safe-top pb-safe-bottom"
      >
        <PaymentDialogHeader 
          clientName={clientName}
          subscription={subscription}
        />
        <div className="flex-1 p-6 overflow-y-auto pb-safe-bottom">
          <PaymentDialogContent
            open={open}
            onOpenChange={onOpenChange}
            clientId={clientId}
            clientName={clientName}
            client={client}
            subscription={subscription}
          />
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default PaymentDialog;
